import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import objectPath from 'object-path';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import { LayoutContextConsumer } from '../LayoutContext';
import * as builder from '../../ducks/builder';
import ButtonAddProduct from '../../../app/components/ui/Buttons/ButtonAddProduct';
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import { IAppState } from '../../../app/store/rootDuck';
import { NewSearchField } from '../../../app/components/NewSearch';
import UserProfile from '../../partials/layout/UserProfile';
import { useModalCategory } from '../categories/categoryContext';

const useStyles = makeStyles()(theme => {
  return {
    cartText: {
      color: theme.palette.secondary.main,
      maxWidth: 350,
      [theme.breakpoints.down(768)]: {
        maxWidth: '100%',
      },
    },
    container: {
      // display: 'flex',
      // flex: 1,
      alignItems: 'center',
      justifyContent: 'flex-end',
      flexDirection: 'row',
      [theme.breakpoints.down(768)]: {
        flexDirection: 'column',
      },
      [theme.breakpoints.down('md')]: {
        alignItems: 'flex-start',
      },
    },
    autoLoc: {
      width: '100%',
    },
    cartBtn: {
      marginLeft: 40,
      marginRight: 20,
      minWidth: 310,
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      position: 'relative',
      justifyContent: 'flex-end',
      [theme.breakpoints.down(768)]: {
        marginLeft: 0,
      },
    },
    wrapSearch: {
      fontWeight: 700,
      width: '100%',
      display: 'flex',
      flex: 1,
      maxWidth: 'calc(100% - 326px - 30px)',
      minWidth: 'calc(326px)',
      [theme.breakpoints.down(768)]: {
        maxWidth: '100%',
        minWidth: '100%',
      },
    },
    btnCatalog: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 44,
      backgroundColor: '#7c97c0',
      borderRadius: 22,
      cursor: 'pointer',
      width: 200,
      [theme.breakpoints.down(600)]: {
        width: '100%',
        padding: '0 10px',
      },
    },
    catalogTitle: {
      fontSize: 16,
      fontWeight: theme.typography.fontWeightRegular,
      color: '#ffffff',
    },
  };
});

const SubHeader = () => {
  const { toggle } = useModalCategory();
  const { classes } = useStyles();
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const matches = useMediaQuery('(max-width:1024px)');
  const isTabletScreen = useMediaQuery(theme.breakpoints.up(1024));

  const { subheaderContainerCssClasses, subheaderCssClasses, subheaderMobileToggle } =
    useSelector((store: IAppState) => ({
      subheaderMobileToggle: objectPath.get(
        store.builder.layoutConfig,
        'subheader.mobile-toggle'
      ),
      subheaderCssClasses: builder.selectors.getClasses(store, {
        path: 'subheader',
        toString: true,
      }),
      subheaderContainerCssClasses: builder.selectors.getClasses(store, {
        path: 'subheader_container',
        toString: true,
      }),
    }));

  const { me } = useSelector((store: IAppState) => ({
    me: store.profile.me,
  }));

  useEffect(() => {
    me?.location &&
      localStorage.setItem(
        'location',
        JSON.stringify({
          address: me.location.address,
          lat: me.location.lat,
          lng: me.location.lng,
        })
      );
  }, [me]);

  return (
    <LayoutContextConsumer>
      {/*{({ subheader: { title, breadcrumb } }) => (*/}

      {({
        subheader: {
          title,
          breadcrumb,
          description,
          show,
          onPress,
          btnTitle,
          back,
          btnAddCart,
          textBtnAddCart,
        },
      }: any) => (
        <div
          id='kt_subheader'
          className={`kt-subheader ${subheaderCssClasses} kt-grid__item`}
          style={{ position: 'fixed', width: '100%', zIndex: 95 }}
        >
          <div className={`kt-container ${subheaderContainerCssClasses} `}>
            <div className='kt-subheader__main '>
              <>
                {subheaderMobileToggle && (
                  <button
                    className='kt-subheader__mobile-toggle kt-subheader__mobile-toggle--left'
                    id='kt_subheader_mobile_toggle'
                  >
                    <span />
                  </button>
                )}

                {isTabletScreen && (
                  <div className='kt-subheader__wrap-left'>
                    {back && (
                      <div style={{ cursor: 'pointer' }} onClick={() => navigate(-1)}>
                        <ArrowBackIosIcon />
                      </div>
                    )}
                    <div className={classes.btnCatalog} onClick={toggle}>
                      <Typography component='p' className={classes.catalogTitle}>
                        {intl.formatMessage({ id: 'PRODUCT.CATALOG.TITLE' })}
                      </Typography>
                    </div>

                    {textBtnAddCart && (
                      <h3
                        onClick={btnAddCart}
                        className='kt-subheader__title'
                        style={{ fontWeight: 600, color: '#7c97c0', cursor: 'pointer' }}
                      >
                        {textBtnAddCart}
                      </h3>
                    )}

                    {location.pathname === '/products/catalog' && (
                      <>
                        <ButtonAddProduct />
                      </>
                    )}
                  </div>
                )}
                <NewSearchField />
                {!matches ? (
                  <div className={classes.container}>
                    <UserProfile showAvatar={true} />
                  </div>
                ) : null}
                {description && <span className='kt-subheader__desc'>{description}</span>}
              </>
            </div>
          </div>
        </div>
      )}
    </LayoutContextConsumer>
  );
};

export default SubHeader;
